"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _keyDownHandler = _interopRequireDefault(require("../../handlers/keyDownHandler"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Toggle = /*#__PURE__*/function (_Component) {
  _inherits(Toggle, _Component);

  var _super = _createSuper(Toggle);

  function Toggle(props) {
    var _this;

    _classCallCheck(this, Toggle);

    _this = _super.call(this, props);
    _this.state = {
      isSetup: false,
      maxWidth: 0,
      checked: props.checked
    };
    return _this;
  }

  _createClass(Toggle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.resetToggleSize();
      this.setState({
        isSetup: true
      });
    } // Based on the textOff and textOn, set the width of the toggle

  }, {
    key: "resetToggleSize",
    value: function resetToggleSize() {
      var width = 0;

      if (this.elTextOn !== undefined) {
        width = this.elTextOn.offsetWidth;
      }

      if (this.elTextOff !== undefined && this.elTextOff.offsetWidth > width) {
        width = this.elTextOff.offsetWidth;
      }

      if (width > this.elToggle.offsetWidth - 24) {
        width = width / 16 + 4;
      } else {
        width = this.elToggle.offsetWidth / 16;
      }

      this.setState({
        isSetup: true,
        maxWidth: width
      });
    }
  }, {
    key: "keyDown",
    value: function keyDown(event) {
      var key = _keyDownHandler["default"].getKeysFromEvent(event);

      if (key === _keyDownHandler["default"].keys.spacebar) {
        this.changeEvent(event);
      }
    }
  }, {
    key: "click",
    value: function click(event) {
      this.changeEvent(event);
    }
  }, {
    key: "changeEvent",
    value: function changeEvent(event) {
      event.preventDefault();

      if (!this.props.disabled) {
        this.setState({
          checked: !this.state.checked
        });
        this.props.onChange({
          target: {
            value: this.props.value,
            checked: this.state.checked
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          colorTheme = _this$props.colorTheme,
          label = _this$props.label,
          textOn = _this$props.textOn,
          textOff = _this$props.textOff,
          className = _this$props.className,
          style = _this$props.style,
          tabIndex = _this$props.tabIndex,
          rest = _objectWithoutProperties(_this$props, ["colorTheme", "label", "textOn", "textOff", "className", "style", "tabIndex"]); // To calculate the width of the longer text we must have both visible


      var initialisationClass = (0, _classnames["default"])({
        "text-init-state": !this.state.isSetup
      });
      var toggleClass = (0, _classnames["default"])("toggle", {
        "disabled": this.props.disabled,
        "checked": this.state.checked
      }, colorTheme, className);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "toggle-component",
        id: this.props.id,
        tabIndex: tabIndex,
        onKeyDown: function onKeyDown(e) {
          return _this2.keyDown(e);
        },
        onClick: function onClick(e) {
          return _this2.click(e);
        }
      }, label !== null && /*#__PURE__*/_react["default"].createElement("label", null, label), /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, rest, {
        checked: this.state.checked,
        disabled: this.props.disabled,
        name: this.props.name
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: toggleClass,
        ref: function ref(el) {
          return _this2.elToggle = el;
        },
        style: {
          width: this.state.maxWidth + 'rem'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "pill",
        style: _objectSpread({
          transform: "translate(".concat(this.state.checked ? this.state.maxWidth - 2.875 : 0, "rem, 0)")
        }, style)
      }), textOn !== null && /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          width: this.state.maxWidth != 0 ? "calc(".concat(this.state.maxWidth, "rem - 1.8125rem - 0.5rem") : 'auto'
        },
        className: "text text-on ".concat(initialisationClass),
        ref: function ref(el) {
          return _this2.elTextOn = el;
        }
      }, textOn), textOff !== null && /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          width: this.state.maxWidth != 0 ? "calc(".concat(this.state.maxWidth, "rem - 1.8125rem - 0.5rem") : 'auto'
        },
        className: "text text-off ".concat(initialisationClass),
        ref: function ref(el) {
          return _this2.elTextOff = el;
        }
      }, textOff)));
    }
  }]);

  return Toggle;
}(_react.Component);

Toggle.propTypes = {
  colorTheme: _propTypes["default"].oneOf(["teal", "grey", "white", 'red', "purple"]),
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  value: _propTypes["default"].string,
  textOn: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),
  textOff: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),
  onChange: _propTypes["default"].func,
  checked: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  tabIndex: _propTypes["default"].number,
  id: _propTypes["default"].string,
  name: _propTypes["default"].string
};
Toggle.defaultProps = {
  colorTheme: "teal",
  label: null,
  name: "",
  value: "",
  textOn: null,
  textOff: null,
  onChange: function onChange() {},
  checked: false,
  disabled: false,
  className: "",
  style: {},
  tabIndex: 1,
  id: null
};
var _default = Toggle;
exports["default"] = _default;